import invalid from '../assets/images/invalid-old.jpg';

const InvalidSession = () => {
    return (
        <div className="other-pages">
            <div className="page__content">
                <div className="thankyou__image">
                    <img src={invalid} alt="Error" />
                </div>
                <p>Sorry, this page can't be found.</p>
            </div>
        </div>
    )
}

export default InvalidSession;